"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "backdrop", (parent) => {
      return React.createElement(this.elementType(parent), {
        key: "blocker-backdrop",
        className: "cg-busy cg-busy-backdrop cg-busy-backdrop-animation"
      });
    });
    __publicField(this, "view", (parent, modalView) => {
      return React.createElement(
        this.elementType(parent),
        {
          key: "blocker-view",
          className: "cg-busy cg-busy-animation"
        },
        React.createElement(
          this.elementType(this.elementType(parent)),
          {
            className: "cg-busy-default-wrapper",
            style: {
              position: "absolute",
              top: "0px",
              left: "0px",
              right: "0px",
              bottom: "0px"
            }
          },
          React.createElement(
            this.elementType(this.elementType(this.elementType(parent))),
            {
              className: "cg-busy-default-container"
            },
            modalView
          )
        )
      );
    });
    __publicField(this, "elementType", (parent) => {
      var type = parent.type || parent;
      if (type === "table") {
        return "tbody";
      } else if (type === "tbody") {
        return "tr";
      } else if (type === "tr") {
        return "td";
      } else {
        return "div";
      }
    });
  }
  render() {
    var child;
    if (this.props.modalView) {
      var children;
      child = React.Children.only(this.props.children);
      if (React.Children.count(child.props.children) === 0) {
        children = [];
      } else if (React.Children.count(child.props.children) === 1) {
        children = [child.props.children];
      } else {
        children = [...child.props.children];
      }
      children.push(this.backdrop(child));
      children.push(this.view(child, this.props.modalView));
      child = React.cloneElement(child, {}, children);
    } else {
      child = this.props.children;
    }
    return child;
  }
}
